import ThreeDSecureWarning from './ThreeDSecureWarning';

export default ThreeDSecureWarning;
